export default __webpack_public_path__ + "88046d1.png";